import { Entry } from 'contentful';

export default class MapTransform {
	public static getSvg(map: Entry<any>): string | undefined {
		if (!map.fields) {
			return undefined;
		}

		// Keep it backward compatible - old "svg" field is a multiline field instead of rich text
		if (map.fields.svg && typeof map.fields.svg === 'string') {
			return map.fields.svg;
		}

		if (map.fields.svg && (map.fields.svg as any).data) {
			return (map.fields.svg as any).content[0].content[0].value;
		}

		return undefined;
	}
}
